import {WsContactSortField} from '@lifeislife/lifeislife-ws-api';

export type ContactField = WsContactSortField;
export const ContactField = WsContactSortField;
